import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useCallback,
  Dispatch,
  SetStateAction,
} from "react";
import { Box, Typography } from "@material-ui/core";
import queryStringParser from "query-string";
import {
  ContactInfoWorkflow,
  IContactInfo,
  TravelerSelectStep,
  ContactInfoStep,
  Header,
  MobilePopoverCard,
  BackButton,
  MobileFloatingButton,
  LoadingPopup,
  B2BSpinner,
  emailRegex,
  phoneRegex,
  Icon,
  IconName,
  InformationalModal as TreesModal,
  TravelWalletSingleSelectionStep,
  HotelCrossSellAwarenessCard,
  VoidWindowNotice,
  GenericInfoPopup,
  MoRBanner,
  TripProtectionBanner,
  useTripProtectionSurvey,
  NotificationBanner,
  BannerSeverity,
} from "halifax";

import "./styles.scss";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import {
  PriceDropProtectionEnum,
  PriceDropViewedProperties,
  PRICE_DROP_VIEWED,
  VIEWED_PRICE_DROP_DETAILS,
  ADD_CONTACT_INFO,
  FlightShopStep,
  FlightBookType,
  ProductFeedLoadingProperties,
  PRODUCT_FEED_LOADING,
  TripCategory,
  FlightShopType,
  INSURANCE_OFFER_SHOWN,
  INSURANCE_OPT_IN_CLICKED,
  INSURANCE_SURVEY_RESPONSE_SUBMITTED,
  UserPreferenceKeyEnum,
} from "redmond";
import clsx from "clsx";
import {
  CDN_ASSETS,
  getConfigTenant,
  isVesperTenant,
  useIsTravelApp,
} from "@capone/common";
import dayjs from "dayjs";
import { FlightShopSummaryPanel } from "../../../../shop/components/FlightShopSummaryPanel";
import { MobileFlightBookWorkflowConnectorProps } from "./container";
import {
  PriceBreakdown,
  FlightBookPassengerSelection,
  PaymentCard,
  FlightBookMobileButton,
  PriceBreakdownDropdown,
  MobileSeatSelection,
  PriceDropProtection,
  PriceDropFOCreditBanner,
  TRIP_PROTECTION_COVERAGE_OPTIONS,
  TRIP_PROTECTION_COVERAGE_OPTIONS_WITHOUT_FINTECH,
  TRIP_PROTECTION_UPGRADE_BANNER_CTA_TEXT,
} from "../..";
import {
  CONTACT_INFO_SAVE,
  CONTINUE,
  CONTACT_INFO_TITLE,
  CONTACT_INFO_SUBTITLE,
  REVIEW_MY_TRIP_TEXT,
  TITLE,
  SUBTITLE,
  PRICE_QUOTE_PASSENGER_VALIDATION_MESSAGE,
  SEAT_SELECTION_TITLE,
  PRICE_QUOTE_MESSAGE,
  CHECKOUT_PRICE_BREAKDOWN_HEADER,
  UPDATE_TRAVELERS,
  EDIT_TRAVELERS,
  TREES_MODAL_CTA_TEXT,
  TREES_MODAL_HEADER,
  TREES_MODAL_SUBTITLE,
  TREES_MODAL_TITLE,
  TREES_BOLDED_MODAL_CTA_TEXT,
} from "./textConstants";
import {
  PATH_BOOK,
  PATH_BOOK_CONFIRMATION,
  PATH_BOOK_WITH_VI_CONFIRMATION,
  PATH_TRIPS,
} from "../../../../../utils/urlPaths";
import { ClientContext } from "../../../../../App";
import { FLIGHTS_REWARDS_DISABLED_BANNER_TEXT } from "../../../../rewards/components/RewardsBanner/constants";
import { AGENT_FEE } from "../../index";
import { trackEvent } from "../../../../../api/v0/analytics/trackEvent";
import { fetchUserMetadata } from "../../../../../api/v0/user/fetchUserMetadata";
import { updateUserMetadata } from "../../../../../api/v0/user/updateUserMetadata";
import { SeatSelectionStep } from "../../MobileSeatSelection";
import {
  AVAILABLE,
  SEAT_SELECTION,
  getExperimentVariant,
  useExperiments,
  TREES_MODAL_EXPERIMENT,
  TRAVEL_WALLET_OFFER_EXPERIMENT,
  getExperimentVariantCustomVariants,
  VOID_WINDOW_EXPERIMENT,
  CREDIT_OFFER_STACKING_V1,
  TRAVEL_CREDIT_HISTORY_EXPERIMENT,
  SEATS_UX_OPTIMIZATION,
  PASSPORT_ENHANCEMENT,
  GLOBAL_MOBILE_NAV_EXPERIMENT,
  CONTROL,
  HOTEL_CROSS_SELL_V3_EXPERIMENT,
  HOTEL_CROSS_SELL_V3_VARIANTS,
  XMOD_V1_EXPERIMENT,
  CORE_FLIGHTS,
  CORE_FLIGHTS_COTA,
  FLIGHTS_TRAVEL_INSURANCE_SMOKE_TEST,
  FLIGHTS_TRAVEL_INSURANCE_SMOKE_TEST_VARIANTS,
  AVAILABLE_WITH_FINTECH,
  FLIGHT_CROSS_SELL_PREFETCH_EXPERIMENT,
} from "../../../../../context/experiments";
import { fetchCustomerDetails } from "../../../../../api/v0/customer/fetchCustomerDetails";
import { usePrevious } from "../../../../../hooks/usePrevious";
import { MobileFlightBookWorkflowStep } from "../../../component";
import { TravelOfferSelection } from "../../TravelOfferSelection";
import { getPriceDropRefundTypeSelector } from "../../../../ancillary/reducer/selectors";
import { MulticityFlightShopStep } from "../../../../shop/reducer";
import {
  IVirtualInterliningVariant,
  VirtualInterliningModal,
} from "../../../../shop/components/VirtualIinterliningModal";
import { MultipleAirlinesFareModal } from "../../../../shop/components/MultipleAirlinesFareModal";
import { useChfarPolicy } from "../../../../change-for-any-reason/hooks/useChfarPolicy";

import { FlightTravelerInformationReadOnly } from "../FlightTravelerInformationReadOnly";
import { useChfarExerciseParams } from "../../../../change-for-any-reason/hooks/useChfarExerciseParams";
import { ChfarImportantInformation } from "../ChfarImportantInformation";
import { ChfarFlightSummaryWrapper } from "../ChfarFlightSummaryWrapper";
import { setChfarExerciseContractId } from "../../../../change-for-any-reason/reducers/exercise/slice";
import { buildCrossSellPrebookingInput } from "../../../../cross-sell/utils/buildCrossSellPrebookingInput";
import { HotelAvailabilityCallState } from "../../../../cross-sell/reducer";
import { parseQueryString } from "../../../../shop/utils/parseQueryString";

export interface IMobileFlightBookWorkflowProps
  extends RouteComponentProps,
    MobileFlightBookWorkflowConnectorProps {
  checkoutStep: MobileFlightBookWorkflowStep;
  setCheckoutStep: Dispatch<SetStateAction<MobileFlightBookWorkflowStep>>;
  localTravelerIds: string[];
  setLocalTravelerIds: (ids: string[]) => void;
  localLapInfantIds: string[];
  setLocalLapInfantIds: (ids: string[]) => void;
}

interface IMobilePaymentCardPopoverProps {
  openPaymentCard: boolean;
  disabled?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onGoBack: () => void;
  mobileHeaderElement?: JSX.Element;
  tripProtectionBanner?: JSX.Element;
}

const MobilePaymentCardPopover = (props: IMobilePaymentCardPopoverProps) => {
  const {
    openPaymentCard,
    disabled = true,
    onClose,
    onConfirm,
    onGoBack,
    mobileHeaderElement,
    tripProtectionBanner,
  } = props;

  const { isTravelApp } = useIsTravelApp();

  return (
    <MobilePopoverCard
      open={openPaymentCard}
      className={clsx("flight-payment-card-popup", "b2b")}
      fullScreen
      onClose={onClose}
      topLeftButton={
        !isTravelApp ? (
          <BackButton
            className="flight-payment-card-popup-back-button"
            onClick={onGoBack}
          />
        ) : undefined
      }
      headerElement={mobileHeaderElement}
    >
      <PaymentCard tripProtectionBanner={tripProtectionBanner} />
      {!disabled && (
        <MobileFloatingButton
          className="flight-book-review-trip-button"
          onClick={onConfirm}
          wrapperClassName="b2b"
          dataTestId="payment-method-continue-button"
        >
          {REVIEW_MY_TRIP_TEXT}
        </MobileFloatingButton>
      )}
    </MobilePopoverCard>
  );
};

export const MobileFlightBookWorkflow = ({
  isWaitingValidation,
  selectedTrip,
  hasNoUserPassengers,
  history,
  finalizedItinerary,
  isBookingValid,
  scheduleQuote,
  setContactInfo,
  confirmationEmail,
  confirmationPhoneNumber,
  priceDropProtection,
  isFareOptimizationCreditShopTime,
  priceDropViewedProperties,
  populateFlightShopQueryParams,
  priceQuote,
  schedulePayment,
  currentSession,
  payments,
  ancillaries,
  seatMapAvailability,
  isWaitingPriceQuote,
  seatMapLoading,
  resetPaymentCardSelectedAccounts,
  priceQuoteErrors,
  hasError,
  errorTitles,
  setFlightShopProgress,
  missingPassport,
  checkoutStep,
  setCheckoutStep,
  flightBookType,
  setFlightBookType,
  fetchApplicableTravelWalletItems,
  localLapInfantIds,
  setLocalLapInfantIds,
  localTravelerIds,
  setLocalTravelerIds,
  fetchInitialCrossSellHotelAvailability,
  hotelAvailabilityCallState,
  airports,
  isVoidWindowEligible,
  isTravelWalletPaymentOnly,
  priceQuoteInProgress,
  creditToApply,
  fetchTravelWalletCreditHistory,
  hasSelectedDisruption,
  smsBeenSelected,
  appNotifBeenSelected,
  toggleAppNotifOptIn,
  toggleSMSOptIn,
  disruptionOptInEnabled,
  tcpaConsentPhoneNumber,
  setUserTcpaConsentPhoneNumber,
  isInternationalFlight,
  setMulticityFlightShopProgress,
  tripCategory,
  tripDetails,
  disruptionDelayThreshold,
  potentialCrossSellOffers,
  setUserSelectedPassengerIds,
  setUserSelectedLapInfantIds,
  pricing,
  setChfarExerciseDiscountAmount,
  fetchUserPassengers,
  userTcpaConsentPhoneNumber,
  userPassengers,
  userSelectedPassengerIds,
  isPaymentCardHidden,
  selectedOnlyNonVXCardPayment,
  hasFintechAttached,
  insuranceBaseTrackingProperties,
}: IMobileFlightBookWorkflowProps) => {
  const dispatch = useDispatch();
  const clientContext = useContext(ClientContext);
  const { sessionInfo, isAgentPortal, isRewardsDisabled } = clientContext;
  const isVesper = isVesperTenant(getConfigTenant());

  const { isTravelApp } = useIsTravelApp();

  const expState = useExperiments();

  const flightsTravelInsuranceSmokeTestVariant =
    getExperimentVariantCustomVariants(
      expState.experiments,
      FLIGHTS_TRAVEL_INSURANCE_SMOKE_TEST,
      FLIGHTS_TRAVEL_INSURANCE_SMOKE_TEST_VARIANTS,
    );
  const isFlightsTravelInsuranceAvailable = useMemo(
    () =>
      flightsTravelInsuranceSmokeTestVariant === AVAILABLE &&
      !hasFintechAttached,
    [flightsTravelInsuranceSmokeTestVariant, hasFintechAttached],
  );
  const isFlightsTravelInsuranceAvailableWithFintech = useMemo(
    () =>
      flightsTravelInsuranceSmokeTestVariant === AVAILABLE_WITH_FINTECH &&
      hasFintechAttached,
    [flightsTravelInsuranceSmokeTestVariant, hasFintechAttached],
  );

  const {
    showBanner: showTripProtectionBanner,
    onSubmit: onTripProtectionSubmit,
  } = useTripProtectionSurvey({
    enabled:
      isFlightsTravelInsuranceAvailable ||
      isFlightsTravelInsuranceAvailableWithFintech,
    metadataKey: UserPreferenceKeyEnum.hasSubmittedFlightsTripProtectionSurvey,
    fetchUserMetadata,
    updateUserMetadata,
  });

  const seatSelectionGroup = getExperimentVariant(
    expState.experiments,
    SEAT_SELECTION,
  );
  const treesModalExperiment = getExperimentVariant(
    expState.experiments,
    TREES_MODAL_EXPERIMENT,
  );

  const isSeatSelection = useMemo(
    () => seatSelectionGroup === AVAILABLE,
    [seatSelectionGroup],
  );

  const isTreesModalExperiment = useMemo(
    () => treesModalExperiment === AVAILABLE,
    [treesModalExperiment],
  );

  const travelWalletOffer = getExperimentVariant(
    expState.experiments,
    TRAVEL_WALLET_OFFER_EXPERIMENT,
  );
  const isTravelWalletOfferExperiment = React.useMemo(
    () => travelWalletOffer === AVAILABLE,
    [travelWalletOffer],
  );

  const creditAndOfferStackingExperimentV1 = getExperimentVariant(
    expState.experiments,
    CREDIT_OFFER_STACKING_V1,
  );
  const isCreditAndOfferStackingExperimentV1 = useMemo(
    () => creditAndOfferStackingExperimentV1 === AVAILABLE,
    [creditAndOfferStackingExperimentV1],
  );

  const travelCreditHistoryExperiment = getExperimentVariant(
    expState.experiments,
    TRAVEL_CREDIT_HISTORY_EXPERIMENT,
  );
  const isTravelCreditHistoryExperiment = useMemo(
    () => travelCreditHistoryExperiment === AVAILABLE,
    [travelCreditHistoryExperiment],
  );

  const crossSellPrefetchExperiment = getExperimentVariant(
    expState.experiments,
    FLIGHT_CROSS_SELL_PREFETCH_EXPERIMENT,
  );
  const isCrossSellPrefetchAvailable = useMemo(
    () => crossSellPrefetchExperiment === AVAILABLE,
    [crossSellPrefetchExperiment],
  );

  const isVoidWindowExperiment = useMemo(
    () =>
      getExperimentVariant(expState.experiments, VOID_WINDOW_EXPERIMENT) ===
      AVAILABLE,
    [expState],
  );

  const isSeatsUXOptimizationExperiment = useMemo(
    () =>
      getExperimentVariant(expState.experiments, SEATS_UX_OPTIMIZATION) ===
      AVAILABLE,
    [expState],
  );
  const hotelCrossSellV3Variant = useMemo(
    () =>
      getExperimentVariantCustomVariants(
        expState.experiments,
        HOTEL_CROSS_SELL_V3_EXPERIMENT,
        HOTEL_CROSS_SELL_V3_VARIANTS,
      ),
    [expState.experiments],
  );

  const isHotelCrossSellV3Experiment = hotelCrossSellV3Variant !== CONTROL;

  const isXmodRedesign =
    getExperimentVariant(expState.experiments, XMOD_V1_EXPERIMENT) ===
    AVAILABLE;

  const isCoreFlights = useMemo(
    () =>
      getExperimentVariant(
        expState.experiments,
        isTravelApp ? CORE_FLIGHTS_COTA : CORE_FLIGHTS,
      ) === AVAILABLE,
    [expState, isTravelApp],
  );

  // Virtual Interline Flights will offer only one type of fare the most basic is safe to only check the first index
  const isVITripSelected = tripDetails.fareDetails[0]?.slices.some((slice) =>
    slice.fareDetails.segments.some((segment) => segment.isSelfTransferLayover),
  );

  // Follows patterns established elsewhere, but the flag is not (yet) needed in this context.
  const [openVIVariantModal, setOpenVIVariantModal] = useState<
    IVirtualInterliningVariant | "reminder" | false
  >(false);

  // Follows patterns established elsewhere, but the flag is not (yet) needed in this context.
  const [openMultipleAirlinesFares, setOpenMultipleAirlinesFares] =
    useState(false);

  const passportEnhancementExperiment = getExperimentVariant(
    expState.experiments,
    PASSPORT_ENHANCEMENT,
  );
  const isPassportEnhancementExperiment = useMemo(
    () => passportEnhancementExperiment === AVAILABLE,
    [passportEnhancementExperiment],
  );

  const isGlobalMobileNavExperiment =
    getExperimentVariant(expState.experiments, GLOBAL_MOBILE_NAV_EXPERIMENT) ===
    AVAILABLE;

  const priceDropRefundType = useSelector(getPriceDropRefundTypeSelector);

  // TODO: remove this when we decide if using text message - https://hopchat.slack.com/archives/C01FX0M22MV/p1620146159000600
  const [contactInfo, setContact] = useState<IContactInfo | null>({
    phoneNumber: confirmationPhoneNumber || "",
    email: confirmationEmail || sessionInfo?.userInfo?.email || "",
  });
  const [customerDetailsLoading, setCustomerDetailsLoading] =
    React.useState<boolean>(true);

  const [isChfarError, setIsChfarError] = useState(false);
  const [hasScheduledQuoteForChfar, setHasScheduledQuoteForChfar] =
    useState(false);
  const [hasSetUpChfarBooking, setHasSetUpChfarBooking] = useState(false);

  const [travelerWorkflowStep, setTravelerWorkflowStep] =
    useState<TravelerSelectStep>(TravelerSelectStep.Main);
  const [contactInfoStep, setContactInfoStep] = useState<ContactInfoStep>(
    ContactInfoStep.Main,
  );
  const [seatSelectionStep, setSeatSelectionStep] = useState<SeatSelectionStep>(
    SeatSelectionStep.Main,
  );
  const [travelWalletSelectStep, setTravelWalletSelectStep] =
    useState<TravelWalletSingleSelectionStep>(
      TravelWalletSingleSelectionStep.Main,
    );
  const [openPaymentCard, setOpenPaymentCard] = useState<boolean>(false);
  const [treeModalOpen, setTreeModalOpen] = useState(false);
  const [updatedInfoOnReview, setUpdatedInfoOnReview] = useState(false);

  const isMulticity: boolean = tripCategory === TripCategory.MULTI_CITY;

  const disruptionDelayThresholdStringInHours =
    disruptionDelayThreshold === 180 ? "3" : "2";

  useEffect(() => {
    if (isMulticity) {
      // Multi-city tracks flight shop progress a little differently. Book is a step in itself.
      setMulticityFlightShopProgress(MulticityFlightShopStep.BookTrip);
    }
  }, []);

  const isPDPEligible =
    priceDropProtection &&
    priceDropProtection.PriceDropProtection ===
      PriceDropProtectionEnum.IsEligible;

  const onBookFlight = () => {
    if (!selectedTrip.tripId) {
      return;
    }
    if (selectedTrip.tripId) {
      if (priceQuote && currentSession && payments && ancillaries) {
        schedulePayment({
          session: currentSession,
          payments,
          ancillaries,
          agentFee: isAgentPortal ? AGENT_FEE : 0,
          initialTime: dayjs().toISOString(),
        });

        // Prefetch the hotel cross-sell now, in parallel with booking, optimistically
        if (
          isCrossSellPrefetchAvailable &&
          hotelAvailabilityCallState === HotelAvailabilityCallState.NotCalled
        ) {
          const prebooking = buildCrossSellPrebookingInput(
            tripDetails,
            airports
          );
          if (prebooking != null) {
            fetchInitialCrossSellHotelAvailability(
              undefined,
              airports,
              prebooking
            );
          }
        }
      } else {
        scheduleQuote({ agentFee: isAgentPortal ? AGENT_FEE : 0 });
      }
    }
  };

  const { itineraryId, contractId, flightShopType } = useChfarExerciseParams();

  const isChfarExercise =
    flightShopType === FlightShopType.CHANGE_FOR_ANY_REASON_EXERCISE;

  const { data: chfarPolicy } = useChfarPolicy(
    { itineraryId: itineraryId as string, contractId: contractId as string },
    !isChfarExercise || !itineraryId || !contractId,
  );

  useEffect(() => {
    if (!isChfarExercise || !chfarPolicy?.coverage) {
      return;
    }

    dispatch(setChfarExerciseContractId(contractId as string));
    setChfarExerciseDiscountAmount(chfarPolicy.coverage);
  }, [
    dispatch,
    setChfarExerciseContractId,
    setChfarExerciseDiscountAmount,
    isChfarExercise,
    chfarPolicy?.coverage,
  ]);

  const hasChfarBookingData = useMemo(
    () =>
      userTcpaConsentPhoneNumber != null &&
      userPassengers.length > 0 &&
      userSelectedPassengerIds.length > 0 &&
      confirmationEmail != null &&
      confirmationPhoneNumber != null &&
      contactInfo != null,
    [
      userTcpaConsentPhoneNumber,
      userPassengers,
      userSelectedPassengerIds,
      confirmationEmail,
      confirmationPhoneNumber,
      contactInfo,
    ],
  );

  const validateChfarBooking = useCallback(() => {
    if (!chfarPolicy) {
      return;
    }

    setFlightBookType(FlightBookType.CHANGE_FOR_ANY_REASON_EXERCISE);
    const { passengerDetails } = chfarPolicy;
    const { contact } = passengerDetails.contact;

    if (!contact) {
      setIsChfarError(true);
      setHasSetUpChfarBooking(false);
    }

    if (!hasChfarBookingData) {
      fetchUserPassengers();
      setUserSelectedPassengerIds({
        userSelectedPassengerIds: passengerDetails.alone.map(
          (p) => p.person.id,
        ),
      });
      setUserSelectedLapInfantIds({
        userSelectedLapInfantIds: passengerDetails.withLapInfants.map(
          (p) => p.adult.person.id,
        ),
      });
      setUserTcpaConsentPhoneNumber(contact.phoneNumber);
      setContact({
        email: contact.emailAddress,
        phoneNumber: contact.phoneNumber,
      });
      setContactInfo(contact.emailAddress, contact.phoneNumber);
      return;
    }

    setHasSetUpChfarBooking(true);
    setIsChfarError(false);
  }, [
    chfarPolicy,
    setUserSelectedPassengerIds,
    setUserSelectedLapInfantIds,
    setUserTcpaConsentPhoneNumber,
    setContactInfo,
    setFlightBookType,
    hasChfarBookingData,
  ]);

  const hasPriceQuoteErrors = priceQuoteErrors.length > 0;

  const shouldSchedulePriceQuoteChfar = useMemo(
    () =>
      priceQuote == null &&
      !isWaitingPriceQuote &&
      !hasPriceQuoteErrors &&
      !hasScheduledQuoteForChfar,
    [
      priceQuote,
      isWaitingPriceQuote,
      hasPriceQuoteErrors,
      hasScheduledQuoteForChfar,
    ],
  );

  const setChfarInitialScreen = useCallback(() => {
    if (isSeatSelection && seatMapAvailability) {
      setCheckoutStep(MobileFlightBookWorkflowStep.SeatSelection);
    } else if (creditToApply) {
      setCheckoutStep(MobileFlightBookWorkflowStep.TravelOfferSelection);
    } else {
      setCheckoutStep(MobileFlightBookWorkflowStep.RewardsAndPayment);
    }
  }, [isSeatSelection, seatMapAvailability, setCheckoutStep]);

  useEffect(() => {
    if (!isChfarExercise) {
      return;
    }

    if (!hasSetUpChfarBooking) {
      validateChfarBooking();
      return;
    }

    if (shouldSchedulePriceQuoteChfar) {
      setHasScheduledQuoteForChfar(true);
      scheduleQuote({
        agentFee: isAgentPortal ? AGENT_FEE : 0,
        pollQuoteOnly: true,
        chfarExercise: { contractId: contractId as string },
      });
      return;
    }

    setChfarInitialScreen();
  }, [
    isChfarExercise,
    setFlightBookType,
    contractId,
    isAgentPortal,
    shouldSchedulePriceQuoteChfar,
    scheduleQuote,
    hasSetUpChfarBooking,
    validateChfarBooking,
    setChfarInitialScreen,
    setHasScheduledQuoteForChfar,
  ]);

  const openFlightBookPassengerSelection = () =>
    setTravelerWorkflowStep(TravelerSelectStep.TravelerSelect);

  const openContactInfoWorkflow = () => {
    setContactInfoStep(ContactInfoStep.ContactInfoForm);
  };

  const openSeatSelectionWorkflow = () => {
    setSeatSelectionStep(SeatSelectionStep.SeatSelection);
  };

  const openTravelOffersSelection = () => {
    setTravelWalletSelectStep(
      TravelWalletSingleSelectionStep.TravelWalletSelection,
    );
  };

  const openPaymentSelection = () => setOpenPaymentCard(true);

  const incrementCheckoutStep = () => {
    const searchParams = new URLSearchParams(history.location.search);
    setCheckoutStep((step: MobileFlightBookWorkflowStep) => {
      switch (step) {
        case MobileFlightBookWorkflowStep.TravelerInformation:
          if (isTravelApp) {
            searchParams.set("bookStep", (step + 3).toString());

            history.push({
              ...history.location,
              search: searchParams.toString(),
            });
          }
          // Skip PricingAndPassengerValidation and AdditionalInformation (corporate-only step)
          return step + 3;

        case MobileFlightBookWorkflowStep.Review:
          if (isTravelApp) {
            searchParams.set("bookStep", step.toString());

            history.push({
              ...history.location,
              search: searchParams.toString(),
            });
          }
          return step;
        case MobileFlightBookWorkflowStep.ContactInformation:
          if (!isSeatSelection || !seatMapAvailability) {
            if (isTravelApp) {
              searchParams.set("bookStep", (step + 3).toString());

              history.push({
                ...history.location,
                search: searchParams.toString(),
              });
            }
            return step + 3;
          }
          if (isTravelApp) {
            searchParams.set("bookStep", (step + 1).toString());

            history.push({
              ...history.location,
              search: searchParams.toString(),
            });
          }
          return step + 1;

        case MobileFlightBookWorkflowStep.SeatSelection:
          if (isPaymentCardHidden) {
            if (isTravelApp) {
              searchParams.set("bookStep", (step + 3).toString());

              history.push({
                ...history.location,
                search: searchParams.toString(),
              });
            }
            return step + 3;
          }
          if (isTravelApp) {
            searchParams.set("bookStep", (step + 2).toString());

            history.push({
              ...history.location,
              search: searchParams.toString(),
            });
          }
          return step + 2;
        case MobileFlightBookWorkflowStep.TravelOfferSelection:
          if (isTravelWalletPaymentOnly) {
            if (isTravelApp) {
              searchParams.set("bookStep", (step + 2).toString());

              history.push({
                ...history.location,
                search: searchParams.toString(),
              });
            }
            return step + 2;
          }
          if (isTravelApp) {
            searchParams.set("bookStep", (step + 1).toString());

            history.push({
              ...history.location,
              search: searchParams.toString(),
            });
          }
          return step + 1;

        default:
          if (isTravelApp) {
            searchParams.set("bookStep", (step + 1).toString());

            history.push({
              ...history.location,
              search: searchParams.toString(),
            });
          }
          return step + 1;
      }
    });
  };

  const parsedQueryString = useMemo(
    () => parseQueryString(history),
    [history.location.search],
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(history.location.search);
    if (isTravelApp) {
      if (!parsedQueryString?.bookStep) {
        searchParams.set("bookStep", checkoutStep.toString());

        history.replace({
          ...history.location,
          search: searchParams.toString(),
        });
      } else if (
        parsedQueryString?.bookStep &&
        Number(parsedQueryString?.bookStep) !== checkoutStep
      ) {
        if (
          Number(parsedQueryString?.bookStep) <= 2 ||
          (Number(parsedQueryString?.bookStep) > 2 && priceQuote)
        ) {
          setCheckoutStep(Number(parsedQueryString?.bookStep));
        }
        searchParams.set("bookStep", "2");

        history.replace({
          ...history.location,
          search: searchParams.toString(),
        });
        setCheckoutStep(MobileFlightBookWorkflowStep.ContactInformation);
      }
    }
  }, [checkoutStep, parsedQueryString?.bookStep, isTravelApp, priceQuote]);

  const handleGoBack = () => {
    switch (checkoutStep) {
      case MobileFlightBookWorkflowStep.TravelerInformation:
        switch (flightBookType) {
          case FlightBookType.CHANGE_FOR_ANY_REASON_EXERCISE:
          case FlightBookType.DEFAULT:
          default:
            if (isCoreFlights) {
              history.goBack();
            } else {
              populateFlightShopQueryParams({
                history,
                prevPath: PATH_BOOK,
                useHistoryPush: true,
                newQueryParams: isMulticity
                  ? {
                      multicityFlightShopProgress:
                        MulticityFlightShopStep.ReviewItinerary,
                    }
                  : {
                      flightShopProgress: FlightShopStep.ReviewItinerary,
                    },
              });
              if (isMulticity) {
                setMulticityFlightShopProgress(
                  MulticityFlightShopStep.ReviewItinerary,
                );
              } else {
                setFlightShopProgress(FlightShopStep.ReviewItinerary);
              }
            }
            break;
        }
        break;
      case MobileFlightBookWorkflowStep.AdditionalInformation:
        // AdditionalInformation is a corporate-only step, skip back to TravelerInformation
        setCheckoutStep(MobileFlightBookWorkflowStep.TravelerInformation);
        break;
      case MobileFlightBookWorkflowStep.ContactInformation:
        // note: skip PricingAndPassengerValidation and AdditionalInformation (corporate-only) step when going back from ContactInformation
        setCheckoutStep(MobileFlightBookWorkflowStep.TravelerInformation);
        break;
      case MobileFlightBookWorkflowStep.SeatSelection:
        switch (flightBookType) {
          case FlightBookType.CHANGE_FOR_ANY_REASON_EXERCISE:
            populateFlightShopQueryParams({
              history,
              prevPath: PATH_BOOK,
              useHistoryPush: true,
              newQueryParams: {
                flightShopProgress: FlightShopStep.ReviewItinerary,
              },
            });
            break;
          default:
            // note: skip PricingAndPassengerValidation step when going back from ContactInformation
            setCheckoutStep(MobileFlightBookWorkflowStep.ContactInformation);
            break;
        }
        break;
      case MobileFlightBookWorkflowStep.TravelOfferSelection:
        switch (flightBookType) {
          case FlightBookType.CHANGE_FOR_ANY_REASON_EXERCISE:
            if (!isSeatSelection || !seatMapAvailability) {
              populateFlightShopQueryParams({
                history,
                prevPath: PATH_BOOK,
                useHistoryPush: true,
                newQueryParams: {
                  flightShopProgress: FlightShopStep.ReviewItinerary,
                },
              });
            } else {
              setCheckoutStep((step: MobileFlightBookWorkflowStep) => step - 1);
            }
            break;
          default:
            if (!isSeatSelection || !seatMapAvailability) {
              setCheckoutStep((step: MobileFlightBookWorkflowStep) => step - 2);
            } else {
              setCheckoutStep((step: MobileFlightBookWorkflowStep) => step - 1);
            }
            break;
        }
        break;
      case MobileFlightBookWorkflowStep.RewardsAndPayment:
        switch (flightBookType) {
          case FlightBookType.CHANGE_FOR_ANY_REASON_EXERCISE:
            if (!isSeatSelection || !seatMapAvailability) {
              populateFlightShopQueryParams({
                history,
                prevPath: PATH_BOOK,
                useHistoryPush: true,
                newQueryParams: {
                  flightShopProgress: FlightShopStep.ReviewItinerary,
                },
              });
            } else {
              setCheckoutStep((step: MobileFlightBookWorkflowStep) => step - 2);
            }
            break;
          default:
            if (!isSeatSelection || !seatMapAvailability) {
              setCheckoutStep((step: MobileFlightBookWorkflowStep) => step - 3);
            } else {
              setCheckoutStep((step: MobileFlightBookWorkflowStep) => step - 2);
            }
            break;
        }
        break;
      case MobileFlightBookWorkflowStep.ApprovalReason:
        if (isPaymentCardHidden) {
          setCheckoutStep((step: MobileFlightBookWorkflowStep) => step - 3);
        } else {
          setCheckoutStep((step: MobileFlightBookWorkflowStep) => step - 1);
        }
        break;

      case MobileFlightBookWorkflowStep.Review:
        if (isPaymentCardHidden) {
          setCheckoutStep((step: MobileFlightBookWorkflowStep) => step - 4);
        } else if (isTravelWalletPaymentOnly) {
          setCheckoutStep((step: MobileFlightBookWorkflowStep) => step - 2);
        } else {
          setCheckoutStep((step: MobileFlightBookWorkflowStep) => step - 1);
        }
        break;
      default:
        setCheckoutStep((step: MobileFlightBookWorkflowStep) => step - 1);
        break;
    }
  };

  const closeAllPopovers = () => {
    if (isSeatSelection) {
      setTravelerWorkflowStep(TravelerSelectStep.Main);
      setContactInfoStep(ContactInfoStep.Main);
      setSeatSelectionStep(SeatSelectionStep.Main);
      setTravelWalletSelectStep(TravelWalletSingleSelectionStep.Main);
      setOpenPaymentCard(false);
    } else {
      setTravelerWorkflowStep(TravelerSelectStep.Main);
      setContactInfoStep(ContactInfoStep.Main);
      setTravelWalletSelectStep(TravelWalletSingleSelectionStep.Main);
      setOpenPaymentCard(false);
    }
  };

  const handlePriceDropTracking = () =>
    trackEvent({
      eventName: VIEWED_PRICE_DROP_DETAILS,
      properties: {
        page:
          checkoutStep === MobileFlightBookWorkflowStep.Review
            ? "trip_review"
            : "payment_summary",
        refund_type: priceDropRefundType,
      },
    });

  const startSchedulePriceQuoteAndResetPayment = () => {
    scheduleQuote({
      agentFee: isAgentPortal ? AGENT_FEE : 0,
      pollQuoteOnly: true,
    });
    // note: reset selected rewards account and payment method ids
    resetPaymentCardSelectedAccounts();
    setUpdatedInfoOnReview(true);
  };

  const renderPriceBreakdownDropdown = (priceBreakdownDropdownProps?: {
    popoverClassName?: string;
    dataTestIds?: {
      popover?: string;
      trigger?: string;
    };
  }) => (
    <PriceBreakdownDropdown
      handlePriceDropTracking={handlePriceDropTracking}
      popoverClassName={priceBreakdownDropdownProps?.popoverClassName}
      dataTestIds={priceBreakdownDropdownProps?.dataTestIds}
    />
  );

  useEffect(() => {
    switch (checkoutStep) {
      case MobileFlightBookWorkflowStep.TravelerInformation:
        closeAllPopovers();
        openFlightBookPassengerSelection();
        break;
      case MobileFlightBookWorkflowStep.AdditionalInformation:
        // AdditionalInformation is a corporate-only step, auto-skip to ContactInformation
        setCheckoutStep(MobileFlightBookWorkflowStep.ContactInformation);
        break;
      case MobileFlightBookWorkflowStep.ContactInformation:
        closeAllPopovers();
        openContactInfoWorkflow();
        break;
      case MobileFlightBookWorkflowStep.SeatSelection:
        closeAllPopovers();
        openSeatSelectionWorkflow();
        break;
      case MobileFlightBookWorkflowStep.TravelOfferSelection:
        closeAllPopovers();
        openTravelOffersSelection();
        break;
      case MobileFlightBookWorkflowStep.RewardsAndPayment:
        closeAllPopovers();
        openPaymentSelection();
        break;
      default:
        break;
    }
  }, [checkoutStep]);

  // note: it handles the PassengerSelection step logic separately from the previous useEffect;
  // when travelerWorkflowStep is being changed too rapidly (e.g.: changing from Main -> TravelerSelect -> TravelerInfoForm because of hasUserPassengers value)
  // it seems to cause some unexpected behaviours on TravelerSelectWorkflow, which in turn causes the Review screen to be unscrollable
  // https://hopper-jira.atlassian.net/browse/BP-1090
  useEffect(() => {
    if (
      checkoutStep === MobileFlightBookWorkflowStep.TravelerInformation &&
      hasNoUserPassengers
    ) {
      setTravelerWorkflowStep(TravelerSelectStep.TravelerInfoForm);
    }
  }, [checkoutStep, hasNoUserPassengers]);

  const prevMissingPassportError = usePrevious(missingPassport);
  useEffect(() => {
    if (
      hasError &&
      (errorTitles.primaryButtonText === UPDATE_TRAVELERS ||
        errorTitles.secondaryButtonText === EDIT_TRAVELERS) &&
      !missingPassport
    ) {
      setCheckoutStep(MobileFlightBookWorkflowStep.TravelerInformation);
    }
    if (prevMissingPassportError && !missingPassport) {
      if (!(!!priceQuoteInProgress && isPassportEnhancementExperiment)) {
        setCheckoutStep(MobileFlightBookWorkflowStep.TravelerInformation); // goes back selection AFTER passport info is updated from the missing passport info error
      }
    }
  }, [
    hasError,
    errorTitles,
    missingPassport,
    priceQuote,
    priceQuoteInProgress,
  ]);

  useEffect(() => {
    if (finalizedItinerary) {
      if (isPDPEligible) {
        const properties: PriceDropViewedProperties = {
          ...priceDropViewedProperties,
          page:
            checkoutStep === MobileFlightBookWorkflowStep.Review
              ? "trip_review"
              : "payment_summary",
        };
        trackEvent({
          eventName: PRICE_DROP_VIEWED,
          properties,
        });
      }

      const properties: ProductFeedLoadingProperties = {
        feed_type: "cross_sell_hotels",
        feed_placement: "flight_confirmation",
      };
      trackEvent({ eventName: PRODUCT_FEED_LOADING, properties });
      // Skip if the confirm-press prefetch done or pending; retry others
      if (
        hotelAvailabilityCallState === HotelAvailabilityCallState.NotCalled ||
        hotelAvailabilityCallState === HotelAvailabilityCallState.Failed
      ) {
        fetchInitialCrossSellHotelAvailability(finalizedItinerary, airports);
      }

      const search = queryStringParser.stringify({
        isTravelApp,
      });

      if (isVITripSelected) {
        history.push({ pathname: PATH_BOOK_WITH_VI_CONFIRMATION, search });
      } else {
        history.push({ pathname: PATH_BOOK_CONFIRMATION, search });
      }
    }
  }, [finalizedItinerary]);

  useEffect(() => {
    if (
      checkoutStep === MobileFlightBookWorkflowStep.Review &&
      !!priceQuote &&
      !priceQuoteInProgress &&
      updatedInfoOnReview
    ) {
      if (isSeatSelection && seatMapAvailability) {
        setCheckoutStep(MobileFlightBookWorkflowStep.SeatSelection); // if seats are avail after PQ is run again, bring user back to step to select seats
      } else if (creditToApply) {
        setCheckoutStep(MobileFlightBookWorkflowStep.TravelOfferSelection); // if user has selected a travel wallet item before PQ is run again on pax/contact info update, bring them back to that step
      } else {
        handleGoBack();
      }
      setUpdatedInfoOnReview(false);
    }
  }, [
    checkoutStep,
    priceQuote,
    priceQuoteInProgress,
    updatedInfoOnReview,
    seatMapAvailability,
  ]);

  useEffect(() => {
    if (isTravelWalletOfferExperiment) {
      fetchApplicableTravelWalletItems();
    }
    if (isTravelCreditHistoryExperiment) {
      fetchTravelWalletCreditHistory();
    }
    const getCustomerDetails = async () => {
      try {
        const details = await fetchCustomerDetails();
        setUserTcpaConsentPhoneNumber(details?.phoneNumber || "");
        setContact({
          email: "",
          ...contactInfo,
          phoneNumber: details?.phoneNumber || "",
        });
        setContactInfo(contactInfo?.email || "", details?.phoneNumber || "");
      } finally {
        setCustomerDetailsLoading(false);
      }
    };

    getCustomerDetails();
  }, []);

  useEffect(() => {
    if (pricing?.totalPricing.total.fiat.value) {
      fetchApplicableTravelWalletItems();
    }
  }, [pricing?.totalPricing.total.fiat.value]);

  useEffect(() => {
    if (
      checkoutStep === MobileFlightBookWorkflowStep.ContactInformation &&
      !!priceQuote
    ) {
      incrementCheckoutStep(); // Increment checkout step AFTER PQ comes back to see if user has seats or not to determine next checkout step
    }
  }, [priceQuote]);

  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 100);
  }, [checkoutStep]);

  return (
    <>
      <Box
        className={clsx("mobile-flight-book-workflow-root", {
          redesigned: isVesper,
          "mobile-review-flight-book":
            checkoutStep === MobileFlightBookWorkflowStep.Review,
          "global-mobile-nav": isGlobalMobileNavExperiment,
          "travel-app": isTravelApp,
        })}
      >
        <Header
          className="mobile-flight-book-workflow-header"
          left={
            !isTravelApp ? (
              <BackButton
                className="mobile-flight-book-header-go-back"
                onClick={handleGoBack}
              />
            ) : undefined
          }
          right={
            checkoutStep === MobileFlightBookWorkflowStep.Review
              ? renderPriceBreakdownDropdown({
                  popoverClassName: "mobile-review-flight-book-price-breakdown",
                })
              : renderPriceBreakdownDropdown()
          }
          isMobile
          fullWidth
        />
        {isVoidWindowExperiment && isVoidWindowEligible && <VoidWindowNotice />}
        <PriceDropFOCreditBanner />
        {priceQuote?.canAirlineBeMor &&
          (payments?.length && payments.length >= 1
            ? selectedOnlyNonVXCardPayment
            : true) && (
            <MoRBanner
              variant={hasFintechAttached ? "book-fintech" : "book"}
              airlineName={tripDetails.slices[0].segmentDetails[0].airlineName}
              isMobile
            />
          )}
        {!isChfarExercise && (
          <Box className="title-summary-container">
            <Typography
              variant={isXmodRedesign ? "h2" : "h6"}
              className="title"
            >
              {TITLE}
            </Typography>
            <Typography variant="body1" className="subtitle">
              {SUBTITLE}
            </Typography>
          </Box>
        )}
        <ChfarFlightSummaryWrapper isChfarExercise={isChfarExercise}>
          <FlightShopSummaryPanel
            showViewDetailsSection
            prevPath={PATH_BOOK}
            isSeatsUXOptimizationExperiment={isSeatsUXOptimizationExperiment}
            isVITripSelected={isVITripSelected}
            setOpenVIVariantModal={setOpenVIVariantModal}
            setOpenMultipleAirlinesFares={setOpenMultipleAirlinesFares}
          />
        </ChfarFlightSummaryWrapper>

        {isHotelCrossSellV3Experiment && potentialCrossSellOffers.length > 0 ? (
          <HotelCrossSellAwarenessCard
            isMobile
            offerText={potentialCrossSellOffers[0].mainDescription}
            offerPillText={potentialCrossSellOffers[0].subDescription}
          />
        ) : undefined}

        {!isChfarExercise && (
          <FlightBookPassengerSelection
            progress={travelerWorkflowStep}
            setProgress={setTravelerWorkflowStep}
            onGoBack={(travelersChanged) => {
              switch (checkoutStep) {
                case MobileFlightBookWorkflowStep.TravelerInformation:
                  handleGoBack();
                  break;
                case MobileFlightBookWorkflowStep.Review:
                  // note: when the user changes passengers on the final step and then clicks the go-back button,
                  // handle it as if the user clicked continue; this is to avoid tricky cases such as having deleted
                  // a selected traveler from list -> requires selected travelers to be updated -> needs to re-schedule price quote
                  if (travelersChanged) {
                    startSchedulePriceQuoteAndResetPayment();
                  }
                  break;
                default:
                  break;
              }
            }}
            onContinue={(travelersChanged) => {
              switch (checkoutStep) {
                case MobileFlightBookWorkflowStep.Review:
                  if (travelersChanged) {
                    startSchedulePriceQuoteAndResetPayment();
                  }
                  break;
                default:
                  incrementCheckoutStep();
                  break;
              }
            }}
            selectionScreenHeaderElement={renderPriceBreakdownDropdown({
              dataTestIds: {
                popover: "flights-passenger-selection-price-breakdown-dialog",
                trigger:
                  "flights-passenger-selection-price-breakdown-dialog-trigger",
              },
            })}
            className="b2b"
            onReviewStep={checkoutStep === MobileFlightBookWorkflowStep.Review}
            isMobile
            useLocalIds
            localLapInfantIds={localLapInfantIds}
            setLocalLapInfantIds={setLocalLapInfantIds}
            localTravelerIds={localTravelerIds}
            setLocalTravelerIds={setLocalTravelerIds}
            showVoidWindowNotice={
              isVoidWindowExperiment && isVoidWindowEligible
            }
            showPassportAwareness={
              isPassportEnhancementExperiment && isInternationalFlight
            }
            hiddenTravelerIds={[]}
          />
        )}
        {!isChfarExercise && (
          <ContactInfoWorkflow
            titles={{
              contactInfoTitle: CONTACT_INFO_TITLE,
              contactInfoSubtitle: CONTACT_INFO_SUBTITLE,
              buttonTitle:
                checkoutStep === MobileFlightBookWorkflowStep.Review
                  ? CONTACT_INFO_SAVE
                  : CONTINUE,
            }}
            isMobile
            progressStep={contactInfoStep}
            setProgressStep={setContactInfoStep}
            contactInfo={contactInfo}
            hasSelectedDisruption={hasSelectedDisruption}
            smsBeenSelected={smsBeenSelected}
            appNotifBeenSelected={appNotifBeenSelected}
            toggleAppNotifOptIn={toggleAppNotifOptIn}
            toggleSMSOptIn={toggleSMSOptIn}
            disruptionOptInEnabled={disruptionOptInEnabled}
            tcpaConsentPhoneNumber={tcpaConsentPhoneNumber}
            onGoBack={() => {
              if (
                checkoutStep === MobileFlightBookWorkflowStep.ContactInformation
              ) {
                handleGoBack();
              }
            }}
            onContactInfoChange={(contactInfoUpdate) => {
              setContact(contactInfoUpdate);
              setContactInfo(
                contactInfoUpdate.email,
                contactInfoUpdate.phoneNumber,
              );
              if (
                contactInfoUpdate.email &&
                contactInfoUpdate.phoneNumber &&
                emailRegex.test(contactInfoUpdate.email) &&
                phoneRegex.test(contactInfoUpdate.phoneNumber)
              ) {
                trackEvent({
                  eventName: ADD_CONTACT_INFO,
                  properties: {},
                });
              }
            }}
            mobileHeaderElement={renderPriceBreakdownDropdown()}
            className="b2b"
            onContinueClick={() => {
              switch (checkoutStep) {
                case MobileFlightBookWorkflowStep.Review:
                  startSchedulePriceQuoteAndResetPayment();
                  break;
                default:
                  scheduleQuote({
                    agentFee: isAgentPortal ? AGENT_FEE : 0,
                    pollQuoteOnly: true,
                  });
                  break;
              }
            }}
            loading={customerDetailsLoading}
            bottomContent={
              isVoidWindowExperiment && isVoidWindowEligible ? (
                <VoidWindowNotice />
              ) : undefined
            }
            disruptionDelayThresholdStringInHours={
              disruptionDelayThresholdStringInHours
            }
            hideBackButton={isTravelApp}
            useXmodHeadings={isXmodRedesign}
            useUpdatedAlertOptIn
          />
        )}
        {isChfarExercise && chfarPolicy && (
          <FlightTravelerInformationReadOnly
            travelers={[
              ...(chfarPolicy.passengerDetails.alone.map((p) => ({
                firstName: p.person.givenName,
                lastName: p.person.surname,
              })) ?? []),
              ...(chfarPolicy.passengerDetails.withLapInfants.map((p) => ({
                firstName: p.adult.person.givenName,
                lastName: p.adult.person.surname,
              })) ?? []),
            ]}
          />
        )}
        {isSeatSelection && (
          <MobileSeatSelection
            title={SEAT_SELECTION_TITLE}
            progressStep={seatSelectionStep}
            setProgressStep={setSeatSelectionStep}
            mobileHeaderElement={renderPriceBreakdownDropdown()}
            onGoBack={() => {
              if (checkoutStep === MobileFlightBookWorkflowStep.SeatSelection) {
                handleGoBack();
              }
            }}
            onContinue={() => {
              if (checkoutStep === MobileFlightBookWorkflowStep.SeatSelection) {
                incrementCheckoutStep();
              } else {
                // if updating seats from review, make user re-select payment
                setCheckoutStep(MobileFlightBookWorkflowStep.RewardsAndPayment);
              }
            }}
            useXmodHeadings={isXmodRedesign}
          />
        )}
        {isTravelWalletOfferExperiment &&
          !isCreditAndOfferStackingExperimentV1 && (
            <TravelOfferSelection
              progressStep={travelWalletSelectStep}
              mobileHeaderElement={<PriceBreakdownDropdown />}
              isMobile
              onGoBack={() => {
                if (
                  checkoutStep ===
                  MobileFlightBookWorkflowStep.TravelOfferSelection
                ) {
                  handleGoBack();
                }
              }}
              onContinueClick={() => {
                incrementCheckoutStep();
                if (isTravelWalletPaymentOnly) {
                  setTravelWalletSelectStep(
                    TravelWalletSingleSelectionStep.Main,
                  );
                }
              }}
            />
          )}
        <Box className="pricing-breakdown-header-wrapper">
          <Box className="pricing-breakdown-header-container">
            <Typography className="header" variant="h6">
              {CHECKOUT_PRICE_BREAKDOWN_HEADER}
            </Typography>
          </Box>
        </Box>
        {priceDropProtection &&
          isPDPEligible &&
          !isFareOptimizationCreditShopTime && (
            <PriceDropProtection
              priceDropProtection={priceDropProtection}
              onClick={handlePriceDropTracking}
            />
          )}
        <PriceBreakdown
          isMobile
          className={clsx({ "less-padding": isTreesModalExperiment })}
        />
        {isRewardsDisabled && (
          <NotificationBanner
            className="rewards-disabled-banner"
            label={FLIGHTS_REWARDS_DISABLED_BANNER_TEXT}
            severity={BannerSeverity.WARNING}
            icon={<Icon className="banner-icon" name={IconName.WarningAlert} />}
          />
        )}
        {isTreesModalExperiment && (
          <TreesModal
            image={CDN_ASSETS.capone.trees.confirmation}
            header={TREES_MODAL_HEADER}
            title={TREES_MODAL_TITLE}
            onClose={() => setTreeModalOpen(false)}
            subtitle={TREES_MODAL_SUBTITLE}
            icon={<Icon className="trees-icon" name={IconName.TreesIcon} />}
            openModal={treeModalOpen}
            setOpenModal={setTreeModalOpen}
            modalLinkCopy={TREES_MODAL_CTA_TEXT}
            modalButtonCopyStartIcon={
              <Icon className="trees-icon" name={IconName.TreesIcon} />
            }
            isMobile
            boldedModalLinkCopy={TREES_BOLDED_MODAL_CTA_TEXT}
          />
        )}
        {isChfarExercise && <ChfarImportantInformation />}
        {isChfarExercise && (
          <GenericInfoPopup
            open={isChfarError}
            title="We couldn't load your contact details"
            subtitle={
              <div>
                For additional assistance, please give us a call at{" "}
                <a href="tel:844-422-6922">844-422-6922</a>
              </div>
            }
            buttons={[
              {
                buttonText: "Go back to My trips",
                onClick: () =>
                  history.push({
                    pathname: PATH_TRIPS,
                  }),
                defaultStyle: "h4r-primary",
              },
            ]}
            isMobile
          />
        )}
        <FlightBookMobileButton
          hasContactInfo={!!contactInfo}
          openContactInfo={() =>
            setContactInfoStep(ContactInfoStep.ContactInfoForm)
          }
          isBookingValid={isBookingValid}
          onConfirmAndBook={onBookFlight}
          // TODO: simplify/trim FlightBookMobileButton logic
          showPaymentStep
          onApplyRewards={() => {}}
          paymentCardOpen={openPaymentCard}
        />
      </Box>
      <MobilePaymentCardPopover
        openPaymentCard={openPaymentCard}
        disabled={!isBookingValid}
        onClose={() => setOpenPaymentCard(false)}
        onConfirm={() => {
          incrementCheckoutStep();
          setOpenPaymentCard(false);
        }}
        onGoBack={() => {
          if (checkoutStep === MobileFlightBookWorkflowStep.RewardsAndPayment) {
            handleGoBack();
          }
        }}
        mobileHeaderElement={renderPriceBreakdownDropdown()}
        tripProtectionBanner={
          isFlightsTravelInsuranceAvailable ||
          isFlightsTravelInsuranceAvailableWithFintech ? (
            <TripProtectionBanner
              hidden={!showTripProtectionBanner}
              isMobile
              coverageOptions={
                isFlightsTravelInsuranceAvailableWithFintech
                  ? TRIP_PROTECTION_COVERAGE_OPTIONS
                  : TRIP_PROTECTION_COVERAGE_OPTIONS_WITHOUT_FINTECH
              }
              ctaText={
                isFlightsTravelInsuranceAvailableWithFintech
                  ? TRIP_PROTECTION_UPGRADE_BANNER_CTA_TEXT
                  : undefined
              }
              onImpression={() =>
                trackEvent({
                  eventName: INSURANCE_OFFER_SHOWN,
                  properties: insuranceBaseTrackingProperties,
                })
              }
              onCtaClick={() =>
                trackEvent({
                  eventName: INSURANCE_OPT_IN_CLICKED,
                  properties: insuranceBaseTrackingProperties,
                })
              }
              onSubmit={(response) => {
                onTripProtectionSubmit();
                trackEvent({
                  eventName: INSURANCE_SURVEY_RESPONSE_SUBMITTED,
                  properties: {
                    ...insuranceBaseTrackingProperties,
                    coverage_options_selected: response.selectedCoverageOptions,
                    likelihood_to_purchase: response.likelihoodToPurchase,
                  },
                });
              }}
            />
          ) : undefined
        }
      />
      <LoadingPopup
        classes={["mobile-price-quote-loading-popup"]}
        open={
          isWaitingPriceQuote ||
          seatMapLoading ||
          (isChfarExercise && !hasSetUpChfarBooking)
        }
        message={
          isWaitingValidation &&
          checkoutStep ===
            MobileFlightBookWorkflowStep.PricingAndPassengerValidation
            ? PRICE_QUOTE_PASSENGER_VALIDATION_MESSAGE
            : PRICE_QUOTE_MESSAGE
        }
        indicator={B2BSpinner}
        indicatorSize="small"
        verticalAlignment="center"
        fullScreen
      />

      {openVIVariantModal && openVIVariantModal !== "reminder" && (
        <VirtualInterliningModal
          isMobile
          variant={openVIVariantModal}
          fareDetails={tripDetails.fareDetails}
          airports={airports}
          isOpen
          onClose={() => setOpenVIVariantModal(false)}
        />
      )}

      {/* openVIVariantModal === "reminder" && (
        <SelfTransferReminderModal
           isOpen
           fareDetails={tripDetails.fareDetails}
           tripDetails={tripDetails}
           onClickContinue={() => {
             trackEvent({
               eventName: CONFIRMED_VI_BAGGAGE_WARNING,
               properties: {},
             });
             populateFlightBookQueryParams({ history });
           }}
           onClickDifferentFlight={() => {
             trackEvent({
               eventName: DECLINED_VI_BAGGAGE_WARNING,
               properties: {},
             });
             setFlightShopProgress(FlightShopStep.ChooseDeparture);
           }}
           onClose={() => setOpenVIVariantModal(false)}
           slices={tripDetails.slices}
           airports={airports}
        />
      ) */}

      {openMultipleAirlinesFares && (
        <MultipleAirlinesFareModal
          isOpen={openMultipleAirlinesFares}
          tripDetails={tripDetails}
          airports={airports}
          onClose={() => setOpenMultipleAirlinesFares(false)}
        />
      )}
    </>
  );
};
